<template>
  <div :style="footerBackground">
    <div class="container">
      <div class="row">
        <div :class="columnClass">
          <h4 :style="textColor">{{ website.title.toUpperCase() }}</h4>
        </div>
        <div
          :class="columnClass"
          v-for="(block, index) in footer.content"
          :key="index"
        >
          <h4 :style="textColor">{{ block.title }}</h4>
          <p v-html="block.body"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterV3",
  props: {
    footer: {
      Type: Object,
      default() {
        return {};
      },
    },
    website: {
      Type: Object,
      default() {
        return {};
      },
    },
    columnSpan: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    footerBackground() {
      return `background-color:${this.footer.background_color};text-color:white;`;
    },
    textColor() {
      return `color:white;`;
    },
    columnClass() {
      return `col-lg-${this.columnSpan} col-md-${this.columnSpan} col-sm-12 col-xs-12 footer-block`;
    },
  },
};
</script>
